// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './en.json';
import trTranslation from './tr.json';


const resources = {
  en: {
    translation: enTranslation,
  },
  tr: {
    translation: trTranslation,
  },
};

// Parse language from the query parameter
const urlParams = new URLSearchParams(window.location.search);  
const languageFromQuery = urlParams.get('lang') || 'tr';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: languageFromQuery,
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;